import { handleGetObjectTypeById } from 'automation-ui-formula-editor/data-sources/queries/getObjectTypeById';
import { useDataFetchingClient } from 'data-fetching-client';
export default function useResolveObjectTypeByIdPromise() {
  const client = useDataFetchingClient();
  return objectTypeId => {
    return handleGetObjectTypeById(objectTypeId, {
      client
    });
  };
}